import { createAction } from '@'
import FetchMappingCoverage, { notifyWrite } from './FetchMappingCoverage'
import GetHotelCoverage from './GetHotelCoverage'

export default createAction('CreateHotel', async body => {
    const data = await FetchMappingCoverage({ method: 'POST', path: '/hotel', data: body })
    notifyWrite(`Hotel ${body.hotel_id} created`, data)
    await GetHotelCoverage({ hotel_id: body.hotel_id })
    return data
})
